/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ReasonForRefusal } from './';
import {
    ReasonForRefusalFromJSON,
    ReasonForRefusalFromJSONTyped,
    ReasonForRefusalToJSON,
} from './';

/**
 * 
 * @export
 * @interface StrategyRefusalRequest
 */
export interface StrategyRefusalRequest {
    /**
     * 
     * @type {ReasonForRefusal}
     * @memberof StrategyRefusalRequest
     */
    reason: ReasonForRefusal;
    /**
     * 
     * @type {string}
     * @memberof StrategyRefusalRequest
     */
    locale: string;
    /**
     * 
     * @type {string}
     * @memberof StrategyRefusalRequest
     */
    emailSubject: string;
    /**
     * 
     * @type {string}
     * @memberof StrategyRefusalRequest
     */
    emailBody: string;
}

/**
 * Check if a given object implements the StrategyRefusalRequest interface.
 */
export function instanceOfStrategyRefusalRequest(value: object): value is StrategyRefusalRequest {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('locale' in value) || value['locale'] === undefined) return false;
    if (!('emailSubject' in value) || value['emailSubject'] === undefined) return false;
    if (!('emailBody' in value) || value['emailBody'] === undefined) return false;
    return true;
}

export function StrategyRefusalRequestFromJSON(json: any): StrategyRefusalRequest {
    return StrategyRefusalRequestFromJSONTyped(json, false);
}

export function StrategyRefusalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StrategyRefusalRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': ReasonForRefusalFromJSON(json['reason']),
        'locale': json['locale'],
        'emailSubject': json['emailSubject'],
        'emailBody': json['emailBody'],
    };
}

export function StrategyRefusalRequestToJSON(value?: StrategyRefusalRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reason': ReasonForRefusalToJSON(value['reason']),
        'locale': value['locale'],
        'emailSubject': value['emailSubject'],
        'emailBody': value['emailBody'],
    };
}

